import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private url = environment.apiUrl
  constructor(private http: HttpClient) { }

  login(username: string, password: String): Observable<any> {
    return this.http.post(`${this.url}/auth/token`, { username: username, password: password })
  }

  resetPassword(oldPassword: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.url}/api/user/reset-password`, { currentPassword: oldPassword, newPassword: newPassword })
  }
}
